import {
  EStatsListVariants,
  IOrStatsListProps,
  TStat,
} from './or-stats-list.types';

export const orStatsListMockData: IOrStatsListProps = {
  variant: EStatsListVariants.BASIC,
  useUppercaseInSubtitle: true,
  stats: [
    { title: '40k+', subtitle: 'Happy Families' },
    { title: '30+', subtitle: 'GLORIOUS YEARS' },
    { title: '38M+', subtitle: 'SqFt. Developed' },
    { title: '45', subtitle: 'Design Centers' },
  ],
};

export const mockHomePlanStats: TStat[] = [
  { title: '4', subtitle: 'Beds' },
  { title: '2.5', subtitle: 'Baths' },
  { title: '2400', subtitle: 'Square Feet' },
  { title: '64 x 54', subtitle: 'Footprint (feet)' },
  { title: 'Included', subtitle: 'Garage' },
];
